export default {"src":"/_next/static/media/pair-2.2b4d8ef3.svg","height":439,"width":458,"blurWidth":0,"blurHeight":0};